import { httpCreate } from './http';
const http = httpCreate('/shop/api/survey/');

export const survey = {
	//获取（单个--详情）
	getSingleInfo(id) {
		return http.get(id + '');
	},
};
